import { createFileRoute } from '@tanstack/react-router';
import { CTASection, DemoCard, Section } from '@cartcloser/ui/marketing';
import { DEMOS } from '../site.js';

export const Route = createFileRoute('/demos')({
  component: DemosPage,
});

function DemosPage() {
  return (
    <div>
      <Section
        eyebrow="Live demos"
        title="Chat with a real agent — no signup"
        subtitle="These are full mock storefronts running CartCloser agents on real catalogues. Open one and ask a hard question."
      >
        <div className="grid gap-6 sm:grid-cols-2">
          {DEMOS.map((demo) => (
            <DemoCard key={demo.name} demo={demo} />
          ))}
        </div>
        <p className="mt-6 text-center text-sm text-muted-foreground">
          More industry demos coming soon. Want yours built first?{' '}
          <a href="/contact" className="font-medium text-primary hover:underline">
            Tell us about your store
          </a>
          .
        </p>
      </Section>

      <CTASection
        title="Want this on your storefront?"
        subtitle="See the same agents running on your own catalogue."
        cta={{ label: 'Contact', href: '/contact' }}
      />
    </div>
  );
}
